<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import QRCode from "qrcode";

/**
 * Starter page component
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      supportedCashierTypes: ["hualala", "yzg", "tcsl", "aoqw"],
      cashierTypeOptions: [
        { value: "hualala", label: "哗啦啦" },
        { value: "yzg", label: "云智付" },
        { value: "tcsl", label: "天财商龙" },
        { value: "aoqw", label: "品智" }
      ],
      title: "",
      items: [],
      loading: true,
      messagelist: [],
      page: 1,
      userinfo: [],
      limit: 20,
      messagetotal: 0,
      cashier_config: [],
      cashier_status: false,
      goodstype: [],
      aoqw_config_preset: "",
      aoqwConfigPresetOptions: [
        { value: "", label: "不选择" },
        { value: "huahs", label: "花和尚餐饮", token: "384aa785de3c0a0ed8c7c873f0750e9f", orderpush: "http://huahs.pinzhikeji.net:8899/pzcatering-gateway/weix/sendOrderDishes.do" }
      ]
    };
  },
  mounted() {
    this.title = this.$t("menuitems.cashier.text");
    this.items = [
      {
        text: this.$t("menuitems.cashier.text"),
        active: true,
      },
    ];
    this.userinfo = JSON.parse(localStorage.getItem("user"));
    //   this.page.title=this.$t('global.notice.type.notify')
    this.get_cashier_config()
  },
  computed: {
    hasNoConfig() {
      return !this.cashier_config || typeof this.cashier_config !== 'object' || !this.cashier_config.type;
    },
    isTypeSupported() {
      return this.cashier_config && this.cashier_config.type && this.supportedCashierTypes.includes(this.cashier_config.type);
    }
  },
  methods: {
    get_cashier_config() {
      var that = this;
      that.loading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "get_cashier_config"
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          if (response.data) {
            that.cashier_status = true;
            that.cashier_config = response.data.config || {};
            if (that.cashier_config.type === 'hualala') {
              that.get_goodstype(that.cashier_config.type);
            }
            if (that.cashier_config.type === 'aoqw') {
              that.syncAoqwConfigPreset();
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    get_goodstype(route) {
      var that = this;
      that.loading = true
      that.$axios
        .post(
          that.apiuri,
          {
            action: "get_" + route + "_catlogs",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false
          that.goodstype = response.data.data.foodCategory;
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    save_cashier_config() {
      var that = this;
      that.loading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "save_cashier_config",
            config: that.cashier_config
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          that.$message({
            message: that.$t("global.success"),
            type: "success",
          });
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    syncAoqwConfigPreset() {
      var opt = this.aoqwConfigPresetOptions.find(o => o.value && o.token === this.cashier_config.token && o.orderpush === this.cashier_config.orderpush);
      this.aoqw_config_preset = opt ? opt.value : "";
    },
    getDefaultConfigByType(type) {
      const base = { type, status: false };
      if (type === "hualala") return Object.assign({}, base, { group_id: "", shopid: "", foodCategoryId: "" });
      if (type === "yzg") return Object.assign({}, base, { bar_id: "", fingerprint: "", certpem: "", uri: "", path: "" });
      if (type === "tcsl") return Object.assign({}, base, { appid: "", access_id: "", center_id: "", shop_id: "", secretKey: "", local_api: "", freedrinktime: "", primaryMenuTypeCode: "" });
      if (type === "aoqw") return Object.assign({}, base, { ognId: "", token: "", orderpush: "" });
      return base;
    },
    onCashierTypeChange(val) {
      this.aoqw_config_preset = "";
      this.cashier_config = this.getDefaultConfigByType(val);
      if (val === "hualala") this.get_goodstype(val);
      if (val === "aoqw") this.syncAoqwConfigPreset();
    },
    onAoqwConfigPresetChange(val) {
      if (!val) {
        this.$set(this.cashier_config, "token", "");
        this.$set(this.cashier_config, "orderpush", "");
        return;
      }
      var opt = this.aoqwConfigPresetOptions.find(o => o.value === val);
      if (opt && opt.token && opt.orderpush) {
        this.$set(this.cashier_config, "token", opt.token);
        this.$set(this.cashier_config, "orderpush", opt.orderpush);
      }
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-loading="loading" v-if="cashier_status">
            <div v-if="hasNoConfig" class="mb-4">
              <el-alert type="info" title="请选择收银系统品牌" description="请选择下方收银系统品牌后进行配置。" show-icon :closable="false" class="mb-3" />
              <el-form label-width="80px">
                <el-form-item label="品牌选择">
                  <el-select v-model="cashier_config.type" placeholder="请选择收银系统品牌" @change="onCashierTypeChange">
                    <el-option v-for="item in cashierTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <el-form v-else label-width="80px" class="mb-4">
              <el-form-item label="品牌选择">
                <el-select v-model="cashier_config.type" placeholder="请选择收银系统品牌" @change="onCashierTypeChange">
                  <el-option v-for="item in cashierTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div v-if="!hasNoConfig && !isTypeSupported" class="mb-4">
              <el-alert type="info" title="不支持详细配置请联系售后配置" description="当前收银系统类型不支持详细配置，请选择上方支持的品牌以切换并覆盖现有设置，或联系售后协助配置。" show-icon :closable="false" class="mb-3" />
              <el-form label-width="80px">
                <el-form-item label="启用状态">
                  <el-switch v-model="cashier_config.status" active-text="启用" inactive-text="禁用" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="save_cashier_config">保存</el-button>
                </el-form-item>
              </el-form>
            </div>
            <template v-else>
              <el-form ref="form" label-width="80px" v-if="cashier_config.type == 'hualala'">
              <el-form-item label="启用状态">
                <el-switch v-model="cashier_config.status" active-text="启用" inactive-text="禁用">
                </el-switch>
              </el-form-item>
              <el-form-item label="集团ID">
                <el-input v-model="cashier_config.group_id"></el-input>
              </el-form-item>
              <el-form-item label="店铺ID">
                <el-input v-model="cashier_config.shopid"></el-input>
              </el-form-item>
              <el-form-item label="商品分类">
                <el-select v-model="cashier_config.foodCategoryId" placeholder="请选择">
                  <el-option v-for="item in goodstype" :key="item.foodCategoryID" :label="item.foodCategoryName"
                    :value="item.foodCategoryID">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="save_cashier_config">保存</el-button>
              </el-form-item>
              <el-form-item>

              </el-form-item>
            </el-form>
            <el-form ref="form" label-width="80px" v-else-if="cashier_config.type == 'yzg'">
              <el-form-item label="启用状态">
                <el-switch v-model="cashier_config.status" active-text="启用" inactive-text="禁用">
                </el-switch>
              </el-form-item>
              <el-form-item label="店铺ID">
                <el-input v-model="cashier_config.bar_id"></el-input>
              </el-form-item>
              <el-form-item label="证书指纹">
                <el-input v-model="cashier_config.fingerprint"></el-input>
              </el-form-item>
              <el-form-item label="证书文件">
                <el-input type="textarea" v-model="cashier_config.certpem"></el-input>
              </el-form-item>
              <el-form-item label="API地址">
                <el-input type="textarea" v-model="cashier_config.uri"></el-input>
              </el-form-item>
              <el-form-item label="API路径">
                <el-input type="textarea" v-model="cashier_config.path"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="save_cashier_config">保存</el-button>
              </el-form-item>
            </el-form>
            <el-form ref="form" label-width="80px" v-else-if="cashier_config.type == 'tcsl'">
              <el-form-item label="启用状态">
                <el-switch v-model="cashier_config.status" active-text="启用" inactive-text="禁用">
                </el-switch>
              </el-form-item>
              <el-form-item label="APPID">
                <el-input v-model="cashier_config.appid"></el-input>
              </el-form-item>
              <el-form-item label="Access ID">
                <el-input v-model="cashier_config.access_id"></el-input>
              </el-form-item>
              <el-form-item label="品牌ID">
                <el-input v-model="cashier_config.center_id"></el-input>
              </el-form-item>
              <el-form-item label="店铺ID">
                <el-input v-model="cashier_config.shop_id"></el-input>
              </el-form-item>
              <el-form-item label="secretKey">
                <el-input v-model="cashier_config.secretKey"></el-input>
              </el-form-item>
              <el-form-item label="本地API地址">
                <el-input v-model="cashier_config.local_api"></el-input>
              </el-form-item>
              <el-form-item label="畅饮单次有效期">
                <el-input v-model="cashier_config.freedrinktime">
                  <template slot="append">小时</template>
                </el-input>
              </el-form-item>
              <el-form-item label="菜品分类编码">
                <el-input v-model="cashier_config.primaryMenuTypeCode"></el-input>
              </el-form-item>
              
              <el-form-item>
                <el-button type="primary" @click="save_cashier_config">保存</el-button>
              </el-form-item>
            </el-form>
            <!-- 品智 aoqw 类型：仅启用开关和门店ID -->
            <el-form ref="form" label-width="80px" v-else-if="cashier_config.type == 'aoqw'">
              <el-form-item label="启用状态">
                <el-switch v-model="cashier_config.status" active-text="启用" inactive-text="禁用">
                </el-switch>
              </el-form-item>
              <el-form-item label="门店ID">
                <el-input v-model="cashier_config.ognId" placeholder="请输入门店ID"></el-input>
              </el-form-item>
              <el-form-item label="配置文件">
                <el-select v-model="aoqw_config_preset" placeholder="请选择" @change="onAoqwConfigPresetChange">
                  <el-option v-for="item in aoqwConfigPresetOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="save_cashier_config">保存</el-button>
              </el-form-item>
            </el-form>
            </template>
          </div>
          <div class="card-body" v-else>
            <el-empty description="当前功能未开通"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>